export default "__VITE_ASSET__0a8dc308__"